<template>
  <div>
    <h2>
      Colaboradores
      <el-button class="float-left"
                 type="primary"
                 v-if="canAdd()"
                 @click="showDialog()">
        Agregar
      </el-button>
    </h2>

    <el-card  :class="{ 'hide-body': !showFilters }">
      <div slot="header" class="d-flex space-between">
        <h4>Filtros</h4>
        <el-button size="mini" plain @click="showFilters = !showFilters">
          <i v-if="!showFilters" class="icon el-icon-arrow-down "></i>
          <i v-if="showFilters" class="icon el-icon-arrow-up "></i>
        </el-button>
      </div>
      <el-row :gutter="10" v-if="showFilters">
        <el-col :md="8">
          <h5>Compañia</h5>
          <el-select v-model="filters.company_id" placeholder="Selecciona una compañia"  style="width: 100%;" @change="getCompanyRelatedData()">
            <el-option
              v-for="item in companies"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="8">
          <h5>Nómina</h5>
          <el-select v-model="filters.payroll_id" placeholder="Selecciona una Nómina"  style="width: 100%;">
            <el-option
              v-for="item in payrolls"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="8">
          <h5>Centro de costo</h5>
          <el-select v-model="filters.cost_centers" placeholder="Selecciona un centro de costo"  style="width: 100%;" multiple >
            <el-option
              v-for="item in cost_centers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="showFilters">
        <el-col :md="12">
          <h5>Estado civil</h5>
          <el-select v-model="filters.civil_status_id"  placeholder="Selecciona un Estado Civil"  style="width: 100%;">
            <el-option
              v-for="item in civilstatuses"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.abb }}</span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="12">
          <h5>Género</h5>
          <el-select v-model="filters.gender" placeholder="Selecciona un género"  style="width: 100%;">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px" v-if="showFilters">
        <el-col :md="24">
          <el-button type="primary" @click="refreshData()" :loading="loading" plain>Cargar Datos</el-button>
          <el-button type="danger" @click="eraseFilters()" :loading="loading" plain>Borrar Filtros</el-button>
          <el-button type="success"  @click="exportReport()" :loading="exporting" plain>Exportar</el-button>
          <el-button type="warning"  @click="exportPersonalActions()" :loading="exportingPersonal" plain>Exportar Acciones de Personal</el-button>
          <el-checkbox class="float-left" v-model="filters.active"><h5>Mostrar solo empleados activos</h5></el-checkbox>
        </el-col>
      </el-row>
    </el-card>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%" :row-class-name="tableRowClassName">
        <el-table-column
          prop="card"
          label="Identidad">
        </el-table-column>
        <el-table-column
          prop="employee_code"
          label="Codigo">
        </el-table-column>
        <el-table-column
          label="Nombre">
          <template slot-scope="scope">
            <p>{{scope.row.names +' '+scope.row.last_names}}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="nationality"
          label="Nacionalidad">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="Teléfono">
        </el-table-column>
        <el-table-column
          :width ="150"
          label="Acciones">
          <template slot-scope="scope">
            <el-button
              v-if="canUpdate()"
              size="mini"
              type="success"
              @click="showElectronicFile(scope.row.id)">
              <i class="el-icon-folder-opened"></i>
            </el-button>
            <el-button
              v-if="canUpdate()"
              size="mini"
              type="warning"
              @click="showDialog(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              v-if="!canUpdate() && canShow()"
              size="mini"
              type="primary"
              @click="showDialog(scope.row)">
              <i class="fa fa-eye"></i>
            </el-button>
            <el-button
              v-if="canDelete()"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :fullscreen = "true"
      center>

      <el-tabs v-model="activeTab" :tab-position="'top'">
        <el-tab-pane name="information">
          <span slot="label">Informaci&oacute;n Personal</span>
          <el-form ref="form" :model="form" label-width="120px" :rules="rules">

            <el-row >
              <el-col :md="11">
                    <picture-input
                      ref="pictureInput"
                      :width="200"
                      :removable="true"
                      removeButtonClass="el-button el-button--danger"
                      :height="200"
                      @change="onChanged"
                      @remove="onRemoved"
                      :alertOnError="false"
                      :prefill="form.image"
                      style="margin-bottom: 10px"
                      accept="image/jpeg, image/png, image/gif"
                      buttonClass="el-button el-button--primary"
                      :customStrings="customPictureInputString">
                    </picture-input>

                <el-form-item v-if="form.id"  label="Cod empleado" prop="employee_code">
                  <el-input v-model="form.employee_code" :disabled="!canEditToSave()" placeholder="1239712EE"></el-input>
                </el-form-item>
                <el-form-item label="Identidad" prop="card">
                  <el-input v-model="form.card" @change="cardChange" :disabled="canEditToSave()" placeholder="123123123"></el-input>
                </el-form-item>
                <el-form-item label="Nombre" prop="names">
                  <el-input v-model="form.names" :disabled="canEditToSave()" placeholder="John Silver"></el-input>
                </el-form-item>
                <el-form-item label="Apellidos" prop="last_names">
                  <el-input v-model="form.last_names" :disabled="canEditToSave()" placeholder="Doe"></el-input>
                </el-form-item>
                <el-form-item label="Género" prop="gender">
                <el-select v-model="form.gender" :disabled="canEditToSave()" placeholder="Seleccione uno opción">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="Fecha de nacimiento" prop="birthdate">
                  <el-date-picker type="date"
                                  :disabled="canEditToSave()"
                                  placeholder="Seleccione una fecha"
                                  v-model="form.birthdate" style="width: 100%;"
                                  format="dd-MM-yyyy"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="Banco" prop="bank_id">
                  <el-select v-model="form.bank_id" :disabled="canEditToSave()" placeholder="Selecciona un Banco" @change="onBankChanged"  style="width: 100%;">
                    <el-option
                      v-for="item in banks"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.abb }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Cuenta bancaria" prop="bank_account" >
                  <el-input v-model="form.bank_account" :disabled="canEditToSave()" placeholder="154121541"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="13">
                <el-form-item label="E-Mail" prop="email">
                  <el-input v-model="form.email" :disabled="canEditToSave()" placeholder="Doe@test.com"></el-input>
                </el-form-item>
                <el-form-item label="Numero Asegurado" prop="insurance_number">
                  <el-input v-model="form.insurance_number" :disabled="canEditToSave()" placeholder="123123123"></el-input>
                </el-form-item>
                <el-form-item prop="civil_status_id" label="Estado Civil">
                  <el-select v-model="form.civil_status_id" :disabled="canEditToSave()" placeholder="Selecciona un Estado Civil"  style="width: 100%;">
                    <el-option
                      v-for="item in civilstatuses"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.abb }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Cantidad de Hijos" prop="child_amount">
                  <el-input type="number" :disabled="canEditToSave()" v-model="form.child_amount"></el-input>
                </el-form-item>
                <el-form-item prop="child_support" label="Pensión Alimenticia">
                  <el-switch
                    v-model="form.child_support"
                    :disabled="canEditToSave()"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Si"
                    inactive-text="No">
                  </el-switch>
                </el-form-item>

                <el-form-item prop="has_embargo" label="Embargo">
                  <el-switch
                    v-model="form.has_embargo"
                    :disabled="canEditToSave()"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Si"
                    inactive-text="No">
                  </el-switch>
                </el-form-item>
                  <el-form-item label="Monto Pensión Alimenticia" prop="child_samount" v-if="form.child_support">
                    <el-input-number v-model="form.child_samount"
                                     :min="0"
                                     controls-position="right"
                                     style="width: 100%;"></el-input-number>
                  </el-form-item>
                <el-form-item label="Nacionalidad" prop="nationality">
                  <el-input v-model="form.nationality" :disabled="canEditToSave()" placeholder="Costa Rica"></el-input>
                </el-form-item>

                <el-form-item label="Dirección" prop="address">
                  <el-input v-model="form.address" :disabled="canEditToSave()" placeholder="San jose, Costa Rica"></el-input>
                </el-form-item>
                <el-form-item label="Teléfono" prop="phone">
                  <el-input v-model="form.phone" :disabled="canEditToSave()" placeholder="+506781241"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div role="alert" v-if="error.message" class="el-alert el-alert--error">
              <div class="el-alert__content">
                <span class="el-alert__title is-bold">{{ error.message }}</span>
                <p class="el-alert__description">
                <ul>
                  <li v-for="item in error.errors">{{ item[0] }}</li>
                </ul>
                </p>
              </div>
            </div>
            <el-alert
              v-if="success"
              title="Se ha guardado exitosamente."
              type="success">
            </el-alert>
            <el-form-item>
              <el-button @click="dialogVisible = false">Cancelar</el-button>
              <el-button type="primary"
                         :loading="processing"
                         v-if="!canEditToSave()"
                         @click="save()">{{actionText}}</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="contracts" v-if="form.id && can('contracts_s')">
          <span slot="label">Contratos</span>
          <contract-list :employee_id="form.id" ></contract-list>
        </el-tab-pane>
        <el-tab-pane name="vacations" v-if="form.id && can('vacations_s')">
          <span slot="label">Vacaciones</span>
          <vacation-list :employee_id="form.id" ></vacation-list>
        </el-tab-pane>
        <el-tab-pane name="incidencias" v-if="form.id && can('incidents_s')">
          <span slot="label">Incidencias</span>
          <incident-list :employee_id="form.id" ></incident-list>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>

</template>
<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
<script>
  import AppTable from '../../components/Table'
  import ContractList from './ContractList'
  import VacationList from './VacationList'
  import IncidentList from './IncidentList'
  import EmployeeProfile from './EmployeeProfile'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'
  import PictureInput from 'vue-picture-input'
  import {Converter, parseError} from '../../packages/Helpers'
  import AwesomeMask from 'awesome-mask'
  import {saveAs} from 'file-saver'
  export default {
    extends: BaseCrud,
    name: 'employee-list',
    directives: {
      'mask': AwesomeMask
    },
    components: {
      AppTable,
      ContractList,
      VacationList,
      IncidentList,
      EmployeeProfile,
      PictureInput
    },
    data () {
      return {
        params: {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },
        activeTab: 'information',
        cost_centers: [],
        companies: [],
        payrolls: [],
        filters: {
          cost_centers: []
        },
        exporting: false,
        exportingPersonal: false,
        showFilters: true,
        methodForUpdate: 'post',
        baseUrl: baseApi + '/employees',
        banksUrl: baseApi + '/banks',
        civilUrl: baseApi + '/civilstatus/getlist',
        companyUrl: baseApi + '/companies',
        payrollsUrl: baseApi + '/payrolls',
        costCentersUrl: baseApi + '/cost-centers',
        basePermission: 'employees',
        customPictureInputString: {
          upload: '<h1>Subir Imagen!</h1>',
          drag: 'Arrastre la imagen aqui'
        },
        loadingBanks: false,
        banks: [],
        civilstatuses: [],
        options: [{
          value: 'Masculino',
          label: 'Masculino'
        }, {
          value: 'Femenino',
          label: 'Femenino'
        }],
        bank_account_mask: '',
        form: {
          birthdate: '',
          card: '',
          names: '',
          last_names: '',
          bank_account: '',
          bank_id: '',
          is_married: 0,
          child_amount: 0,
          child_support: 0,
          nationality: '',
          address: '',
          phone: '',
          gender: '',
          email: '',
          employee_code: '',
          insurance_number: '',
          contracts: [],
          image: ''
        },
        dialogTitle: 'Agregar Empresa',
        rules: {
          card: [{ required: true, message: 'La identificación es requerida', trigger: 'blur' }],
          names: [{ required: true, message: 'el nombre es requerido', trigger: 'blur' }],
          last_names: [{ required: true, message: 'Los apellidos son requeridos', trigger: 'blur' }],
          bank_account: [{ required: false, message: 'La cuenta bancaria es requerida', trigger: 'blur' }],
          birthdate: [{ required: true, message: 'La fecha de nacimiento es requerida', trigger: 'change' }],
          bank_id: [{ required: true, message: 'El banco es requerido', trigger: 'blur' }],
          civil_status_id: [{ required: true, message: 'El estado civil es requerido', trigger: 'blur' }],
          nationality: [{ required: true, message: 'La Nacionalidad es requerida', trigger: 'blur' }],
          address: [{ required: true, message: 'La dirección es requerida', trigger: 'blur' }],
          phone: [{ required: true, message: 'El telefono es requerido', trigger: 'blur' }],
          gender: [{ required: true, message: 'El genero es requerido', trigger: 'blur' }],
          email: [{ required: true, message: 'El E-mail es requerido', trigger: 'blur' },
            { type: 'email', message: 'El correo debe tener el formato correcto', trigger: 'blur,change' }],
          insurance_number: [{ required: false, message: 'El numero de asegurado es requerido', trigger: 'blur' }]
        }
      }
    },
    methods: {
      async cardChange (card) {
        const result = (await this.$http.get(`${this.baseUrl}/${card}/blacklist`)).body

        if (result.exists) {
          this.$alert('La identificación ingresada se encuentra en la lista de no recontratable.', '¡Advertencia!', {
            confirmButtonText: 'OK',
            type: 'warning'
          })
        }
      },
      showElectronicFile (id) {
        this.$router.push('employees/' + id + '/profile')
      },
      tableRowClassName ({row}) {
        if (row.blacklist === 1) {
          return 'warning-row'
        }
        return ''
      },
      afterShowDialog () {
        this.activeTab = 'information'
      },
      eraseFilters () {
        this.filters = {
          cost_centers: []
        }
        this.cost_centers = []
        this.payrolls = []
        this.refreshData()
      },
      onBankChanged (bankId) {
        console.log(bankId)
        const index = this.getBankFromId(item => item.id === bankId)
        console.log(index)
        if (index > -1) {
          this.bank_account_mask = `${this.banks[index].mask}`
          console.log(this.banks[index])
        }
      },
      getBankFromId (cond) {
        const item = this.banks.find(cond)
        return this.banks.indexOf(item)
      },
      _beforeSend (value) {
        return Converter.objectToFormData(value)
      },
      onChanged () {
        if (this.$refs.pictureInput.file) {
          this.form.image = this.$refs.pictureInput.file
        } else {
          alert('Old browser. No support for Filereader API')
        }
      },
      onRemoved () {
        this.form.image = ''
      },
      _getDeleteTitle (model) {
        return 'Esta seguro que desea elimnar ' + model.names + ' ' + model.last_names
      },
      getBanks () {
        this.loadingBanks = true
        this.$http.get(this.banksUrl)
          .then(
            (res) => {
              this.banks = res.body
              this.loadingBanks = false
              this.bank_account_mask = this.banks[0].mask
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
              this.loadingBanks = false
            }
          )
      },
      getCivil () {
        this.$http.get(this.civilUrl)
          .then(
            (res) => {
              this.civilstatuses = res.body
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
        this.$http.get(this.companyUrl)
          .then(
            (res) => {
              this.companies = res.body
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
      },
      getCompanyRelatedData () {
        if (this.filters.company_id) {
          this.filters.cost_centers = []
          delete this.filters.payroll_id
          this.$http.get(this.payrollsUrl + '?company_id=' + this.filters.company_id)
            .then(
              (res) => {
                this.payrolls = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )

          this.$http.get(this.costCentersUrl + '?company_id=' + this.filters.company_id)
            .then(
              (res) => {
                this.cost_centers = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )
        }
      },
      exportReport () {
        const query = {
        }
        if (this.filters.company_id) {
          query['company_id'] = this.filters.company_id
        }
        if (this.filters.payroll_id) {
          query['payroll_id'] = this.filters.payroll_id
        }

        if (this.filters.cost_centers) {
          query['cost_centers'] = this.filters.cost_centers
        }
        if (this.filters.gender) {
          query['gender'] = this.filters.gender
        }
        if (this.filters.active) {
          query['active'] = this.filters.active
        }
        if (this.filters.civil_status_id) {
          query['civil_status_id'] = this.filters.civil_status_id
        }
        let url = this.baseUrl + '/reports/excel'
        this.exporting = true
        let data = Object.assign({}, query)
        data = this._beforeSend(data)
        this.$http.post(url, data, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina '

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      refreshData () {
        const query = {
          page: this.current_page,
          paginate: true
        }
        if (this.filters.company_id) {
          query['company_id'] = this.filters.company_id
        }
        if (this.filters.payroll_id) {
          query['payroll_id'] = this.filters.payroll_id
        }

        if (this.filters.cost_centers) {
          query['cost_centers'] = this.filters.cost_centers
        }

        if (this.filters.gender) {
          query['gender'] = this.filters.gender
        }

        if (this.filters.active) {
          query['active'] = this.filters.active
        }
        if (this.filters.civil_status_id) {
          query['civil_status_id'] = this.filters.civil_status_id
        }
        if (this.search !== '' && this.search !== undefined) {
          query.term = this.search
        }

        this._beforeRefresh(query)
        this.loading = true
        let data = Object.assign({}, query)
        data = this._beforeSend(data)
        this.$http.post(this.baseUrl + '/table/data', data, this.params)
          .then(
            (res) => {
              this.tableData = res.body.data
              this.total = res.body.total
              this.loading = false
              this._afterRefresh()
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
              this.loading = false
            }
          )
      },
      _mounted () {
        this.getBanks()
        this.getCivil()
      },
      _formatModel (model) {
        if (typeof (model.child_support) !== typeof (true)) {
          model.child_support = parseInt(model.child_support)
        }
        model.child_support = (model.child_support === 1 || model.child_support === true)
        if (typeof (model.has_embargo) !== typeof (true)) {
          model.has_embargo = parseInt(model.has_embargo)
        }
        model.has_embargo = (model.has_embargo === 1 || model.has_embargo === true)
        model.bank_id = parseInt(model.bank_id)
        model.civil_status_id = parseInt(model.civil_status_id)
      },
      exportPersonalActions () {
        const query = {}

        if (this.filters.company_id) {
          query['company_id'] = this.filters.company_id
        }
        if (this.filters.payroll_id) {
          query['payroll_id'] = this.filters.payroll_id
        }

        if (this.filters.cost_centers) {
          query['cost_centers'] = this.filters.cost_centers
        }

        if (this.filters.gender) {
          query['gender'] = this.filters.gender
        }

        if (this.filters.active) {
          query['active'] = this.filters.active
        }
        if (this.filters.civil_status_id) {
          query['civil_status_id'] = this.filters.civil_status_id
        }
        if (this.search !== '' && this.search !== undefined) {
          query.term = this.search
        }

        let url = baseApi + '/personal-actions/reports/excel'
        this.exportingPersonal = true
        this.$http.post(url, query, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              saveAs(blob, 'Acciones de Personal.xlsx')
              this.exportingPersonal = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exportingPersonal = false
            }
          )
      }
    }
  }
</script>
<style>
  .float-left{
    float: right;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/employees/Index.vue